import { render, staticRenderFns } from "./SetPaperStepTwoAskAnswer.vue?vue&type=template&id=21791677&scoped=true&"
import script from "./SetPaperStepTwoAskAnswer.vue?vue&type=script&lang=js&"
export * from "./SetPaperStepTwoAskAnswer.vue?vue&type=script&lang=js&"
import style0 from "./SetPaperStepTwoAskAnswer.vue?vue&type=style&index=0&id=21791677&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21791677",
  null
  
)

export default component.exports